namespace advisorop.services {
    "use strict";
    export class AccountGeneralService {

        static $inject = ["$http", "$q", "$rootScope"];
        constructor(private $http: ng.IHttpService,
            private $q: ng.IQService, private $rootScope: ng.IRootScopeService) {
        }

        isCustodianRequired(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            return investmentType == domains.InvestmentType.INDIVIDUAL_HOLDINGS;
        }

        hasRtg = (investmentType: domains.InvestmentType, hasRtgHoldings: boolean = false): boolean => {
            return (investmentType !== domains.InvestmentType.OUTSIDE_INVESTMENT) || hasRtgHoldings;
        }

        hasProposal(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            // proposal should be available for Managed Investments and Individual Holdings
            // for Individual holdings without Investments
            // and Direct Accounts with product type General Investments  or REIT ( IRA + Other retairment)
            return investmentType == domains.InvestmentType.MANAGED_MODELS
                || investmentType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                || investmentType == domains.InvestmentType.SMA;
        }

        hasSubscriptionAgreement(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            // subscription document should be printed and signed for Direct Investments
            // but only when Proposal step is not available for Direct Investments
            return (investmentType == domains.InvestmentType.DIRECT_INVESTMENT)
                && !this.hasProposal(investmentType);
        }

        hasCustodian(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            return investmentType == domains.InvestmentType.MANAGED_MODELS
                || investmentType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                || investmentType == domains.InvestmentType.SMA;
        }

        hasAutoGeneratedAccount(custodian: domains.ICustodian): boolean {
            return custodian && (custodian.name == "Pershing");
        }

        hasProductType(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            return (investmentType == domains.InvestmentType.DIRECT_INVESTMENT
                 || investmentType == domains.InvestmentType.OUTSIDE_INVESTMENT);
        }

        // 0-has no manager field
        // 1-has drop down to select manager
        // 2-has input field to type manager/company
        hasManager(investmentType: domains.InvestmentType): number {
            if (!investmentType) return 0;
            if (investmentType == domains.InvestmentType.DIRECT_INVESTMENT)
                return 1;
            else if (investmentType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                return 2;
            else
                return 0;
        }
        
        hasTamp(investmentType: domains.InvestmentType): boolean {
            if (!investmentType) return false;
            return (investmentType == domains.InvestmentType.MANAGED_MODELS || investmentType == domains.InvestmentType.SMA);
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service("accountGeneralService", AccountGeneralService);
}